var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.199219,
    y: 0.418945,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#DFC070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.663 27.4189V19.2083H22.5577L22.9911 16.0084H19.6629V13.9655C19.6629 13.039 19.9331 12.4077 21.3285 12.4077L23.1082 12.4069V9.54502C22.8004 9.50609 21.7439 9.41895 20.5149 9.41895C17.9489 9.41895 16.1922 10.9101 16.1922 13.6487V16.0084H13.29V19.2083H16.1922V27.4189H19.663V27.4189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.e43a025a3c478b6e8668f141fa0b42ac.svg";
export { ForwardRef as ReactComponent };